module.exports = __webpack_public_path__ + "assets/allyshipIcon1.425834fc.svg";